import { Component, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { ClientService } from '../../services/client.service';
import { trigger, transition, style, animate, useAnimation, query, stagger, keyframes } from '@angular/animations';
import { bounce } from 'ng-animate';
import { AddLocationComponent } from './add-location/add-location.component';
import { AddClientModalComponent } from '../add-client-modal/add-client-modal.component'
import { UtilityService } from '../../services/utility.service';
import { Bool } from 'aws-sdk/clients/clouddirectory';
@Component({
  selector: 'app-single-client',
  templateUrl: './single-client.component.html',
  styleUrls: ['./single-client.component.scss'],
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ height: 0, opacity: 0 }),
            animate('1s ease-out',
              style({ height: 300, opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ height: 300, opacity: 1 }),
            animate('1s ease-in',
              style({ height: 0, opacity: 0 }))
          ]
        )
      ]
    ),
    trigger('bounce', [transition('* => *', useAnimation(bounce))]),
    trigger('listAnimation', [
      transition('* => *', [ // each time the binding value changes
        query(':leave', [
          stagger(100, [
            animate('0.5s', style({ opacity: 0 }))
          ])
        ], { optional: true }),
        query(':enter', [
          // style({ opacity: 0 }),
          stagger(100, [

            animate('1s ease-in', keyframes([
              style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
              style({ opacity: .5, transform: 'translateY(35px)', offset: 0.3 }),
              style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
            ]))
          ])
        ], { optional: true })
      ])
    ])
  ]
})
export class SingleClientComponent implements OnInit {
  client;
  addLocationPopup;
  loading;
  data: any;
  hide = false
  @Output() locationEmitter: EventEmitter<any> = new EventEmitter<any>();
  selectedLocationIndex: any;
  currentUser: any;
  user;
  deletUser = false
  isDisplay: boolean = false
  constructor(
    private activatedRoute: ActivatedRoute,
    private _clientService: ClientService,
    public dialog: MatDialog,
    public _utilityService: UtilityService
  ) {
    this.data = {
      title: ""
    }
  }


  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (!this.user.isAdmin) {
      this.hide = true
    }
    console.log('location Output', location);
    this.activatedRoute.params.subscribe(params => {
      console.log(params['id']);
      this._clientService.getClient(params['id']).subscribe(data => {
        console.log("RECEIVED = ", data)
        if (data) this.client = data.pop();
        console.log("THIS CLIENT LOCATIONS ARRAY = ", this.client);
        if (this.client && this.client.isClient) this.isDisplay = true
        if (this.client && (!this.client.isClient && this.client.isAllow)) this.isDisplay = true
        if (this.client && this.client.isDelete == true) {
          console.log("call this or not");

          this.deletUser = true
        } else {
          this.deletUser = false
        }
      });
    })

  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('location Output in change', location);

  }


  // UTILITY
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '800px', height: '800px' });
    return dialogRef.afterClosed();
  }
  addLocationModal() {
    let addLocation = this.openDialog(AddLocationComponent, this.client.locations).subscribe((location) => {
      console.log("Added location", location)
      if (location == undefined) return;
      if (location.title == "") {
        return;
      }
      else {
        let obj = {
          client: this.client._id,
          location: location
        };
        console.log("Data to send = ", obj);
        this.loading = true;
        this._clientService.addLocation(obj).subscribe(res => {
          console.log("Response = ", res)
          this.client.locations.push(res);
        }, err => {
          console.error(err);
        },
          () => {
            this.loading = false;
          });
      }
    })
  }

  deletedLocation(id) {
    this.client.locations.splice(this.client.locations.findIndex(function (i) {
      return i._id === id;
    }), 1);
  }

  selectedLocation(event) {
    console.log('selectedLocation', event);
    this.selectedLocationIndex = event.index
    this.locationEmitter.emit(event);
  }

  validate(data) {
    console.log("Validating ", data);
    if (!data.title) return false;

    return true;
  }


  addNewUser() {
    let obj = {
      isClient: false,
      masterClientId: this.client._id
    }
    this._utilityService.commonDialogBoxOpen(AddClientModalComponent, obj)
      .afterClosed().subscribe((res) => {
        if(res == undefined) return res 
        else 
        console.log("Response of new user added from client side", res);
        this._utilityService.handleSnackBar({ msg: "User added successfully!", button: "OK" })
      })
  }
}

